function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'polished-brass': 'url("//www.doortodoorco.com/cdn/shop/files/polished_brass_68x.png?v=8797484584065537290")','rubbed-bronze': 'url("//www.doortodoorco.com/cdn/shop/files/rubbed_bronze_68x.png?v=12232561566046542032")','polished-chrome': 'url("//www.doortodoorco.com/cdn/shop/files/polished_chrome_68x.png?v=16283240934706692505")','satin-nickel': 'url("//www.doortodoorco.com/cdn/shop/files/satin_nickel_68x.png?v=3486588659520266082")','matte-black': 'url("//www.doortodoorco.com/cdn/shop/files/matte_black_68x.png?v=8854130595429340462")','left-hand-inswing': 'url("//www.doortodoorco.com/cdn/shop/files/lefthandinswing_68x.png?5960")','right-hand-inswing': 'url("//www.doortodoorco.com/cdn/shop/files/right_hand_inswing_68x.png?5960")','left-hand-outswing': 'url("//www.doortodoorco.com/cdn/shop/files/left_hand_outswing_68x.png?5960")','right-hand-outswing': 'url("//www.doortodoorco.com/cdn/shop/files/right_hand_outswing_68x.png?5960")',};

    this.triggers = ['color','colour','couleur','farbe','cor','select hinge finish','select handing & swing',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
